(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
function wmFooterInit(){
  document.querySelectorAll('#wm-footer').forEach(root=>{
    if(root.dataset.ready)return;
    root.dataset.ready='true';
    let mobile;
    new ResizeObserver(entries=>{
      const narrow=entries[0].contentRect.width<=440;
      if(narrow!==mobile){root.querySelectorAll('details').forEach(d=>{d.open=!narrow;});mobile=narrow;}
    }).observe(root.querySelector('footer'));
  });
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',wmFooterInit);else wmFooterInit();
document.addEventListener('shopify:section:load',wmFooterInit);

  } catch(e) { console.error(e); }
})();
})();
